import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { FlamingoChangePasswordDialogComponent } from '../component/flamingo-change-password-dialog.component';
import { FlamingoConfirmDialogComponent } from '../component/flamingo-confirm-dialog.component';
import { FlamingoInputDialogComponent } from '../component/flamingo-input-dialog.component';

@Injectable()
export class FlamingoMessageService {
  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {}

  showMessage(message: string, duration: number = 5000): void {
    this.snackBar.open(message, null, { duration: duration });
  }

  showMessageWithConfirm(message: string, action: string = 'OK'): void {
    this.snackBar.open(message, action);
  }

  showModal(
    component: any,
    data: any = {},
    autoFocus?: boolean,
    disableClose?: boolean,
    width?: number,
  ): Observable<any> {
    return this.dialog
      .open(component, {
        width: (width ? width : '600') + 'px',
        autoFocus: autoFocus,
        disableClose: disableClose,
        data: data,
      })
      .afterClosed();
  }

  showModalWithConfiguration(component: any, config: MatDialogConfig): MatDialogRef<any, any> {
    return this.dialog.open(component, config);
  }

  showConfirmDialog(
    title?: string,
    description?: string,
    cancel?: string,
    confirm?: string,
    width?: number,
  ): Observable<boolean> {
    return this.dialog
      .open(FlamingoConfirmDialogComponent, {
        width: (width ? width : '400') + 'px',
        data: {
          title: title ? title : 'Confirm',
          description: description ? description : 'Are you sure?',
          cancel: cancel ? cancel : 'Cancel',
          confirm: confirm ? confirm : 'Confirm',
        },
      })
      .afterClosed();
  }

  showMessageDialog(
    title?: string,
    description?: string,
    confirm?: string,
    width?: number,
  ): Observable<boolean> {
    return this.dialog
      .open(FlamingoConfirmDialogComponent, {
        width: (width ? width : '400') + 'px',
        data: {
          title: title ? title : 'Confirm',
          description: description ? description : 'Are you sure?',
          confirm: confirm ? confirm : 'Confirm',
        },
      })
      .afterClosed();
  }

  showInputDialog(
    title?: string,
    description?: string,
    placeholder?: string,
    type?: string,
    cancel?: string,
    confirm?: string,
    width?: number,
  ): Observable<string> {
    return this.dialog
      .open(FlamingoInputDialogComponent, {
        width: (width ? width : '400') + 'px',
        data: {
          title: title ? title : 'Input',
          description: description ? description : 'Insert text',
          inputPlaceholder: placeholder ? placeholder : 'Label',
          inputType: type ? type : 'string',
          actionCancel: cancel ? cancel : 'Cancel',
          actionConfirm: confirm ? confirm : 'Confirm',
        },
      })
      .afterClosed();
  }

  showChangePasswordDialog(
    title?: string,
    description?: string,
    oldPassword?: string,
    newPassword?: string,
    repeatPassword?: string,
    type?: string,
    cancel?: string,
    confirm?: string,
    width?: number,
  ): Observable<any> {
    let passwordDialogRef: MatDialogRef<FlamingoChangePasswordDialogComponent>;
    passwordDialogRef = this.dialog.open(FlamingoChangePasswordDialogComponent, {
      width: (width ? width : '400') + 'px',
      data: {
        title: title ? title : 'Input',
        description: description ? description : '',
        inputOldPassword: oldPassword ? oldPassword : 'Label',
        inputNewPassword: newPassword ? newPassword : 'Label',
        inputRepeatPassword: repeatPassword ? repeatPassword : 'Label',
        inputType: type ? type : 'string',
        actionCancel: cancel ? cancel : 'Cancel',
        actionConfirm: confirm ? confirm : 'Confirm',
      },
    });
    return passwordDialogRef.afterClosed();
  }
}
